import Info from './Info';
import Fields from './Fields';

export default {
  Info,
  Fields,
};
